<template>
<!-- <img alt="Vue logo" src="./assets/logo.png"> -->
<div id="app">
    <!-- <notifications group="foo" position="top right" width="225px" /> -->
    <router-view />
</div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
// import Login from './components/Login.vue';
import { mapActions } from 'vuex'

export default {
		name: 'app',
		methods:{
			...mapActions({
               
            })
		},	
        components: {},
        
 }
</script>

<style>
/* #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
} */
  @Import '../static/css/stylesheet.css';
  @import '../static/css/bootstrap-vue.min.css';
</style>
